import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Platform } from '@ionic/angular/standalone';
import { IDEAStorageService } from '@idea-ionic/common';
import { AuthService } from 'src/app/common/auth.service';
import { AppStore } from './common/app.store';

export const authGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const platform = inject(Platform);
  const storage = inject(IDEAStorageService);
  const auth = inject(AuthService);
  const router = inject(Router);
  const app = inject(AppStore);

  if (app.authReady()) return true;
  await platform.ready();
  await storage.ready();
  try {
    await auth.doAuth();
    //platform.resume.subscribe((): Promise<void> => auth.doAuth());

    if (window.location.pathname === '/') return router.parseUrl('');
    else return true; //proceed with selected route
  } catch (err) {
    return router.parseUrl('auth');
  }
};
